/**
 * useCanonical — DEPRECATED no-op shim.
 *
 * Why this is a no-op:
 *   Per the 2026-05-17 SEO audit (Papi's brief), client-side scripts that
 *   mutate <link rel="canonical"> after first paint confuse Google's
 *   crawler. The build-time prerender (see /app/frontend/prerender.js) is
 *   now the single source of truth for canonical tags:
 *     - At build time, every route in /app/frontend/seo-routes.js gets a
 *       static <link rel="canonical"> baked into its per-route index.html
 *     - At runtime, the inline injector ONLY runs if the SPA fallback
 *       served the wrong index.html (marker mismatch), and even then it
 *       writes the SAME canonical that the prerender would have
 *
 * This hook is kept as a no-op so existing call sites don't break.
 * Remove call sites at your leisure; this file can be deleted once they're
 * all gone.
 */
// useCanonical is intentionally a no-op (see file header). The legacy
// signature is preserved so existing callers don't break.
export const useCanonical = () => {
  // no-op
};
